<div class="main-content">

  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--green">
        <i class="fas fa-magnifying-glass-chart"></i>
      </div>
      <div>
        <h1 class="main-title">Controllo Picking TP</h1>
        <p class="main-subtitle">Consultazione dei colli pickerati, pickerabili e non pickerati per viaggio</p>
      </div>
    </div>

    <div class="platform-filter" [class.platform-filter--missing]="false" *ngIf="!isSingleWarehouseUser">
      <div class="platform-filter-icon">
        <i class="fas fa-warehouse"></i>
      </div>
      <div class="platform-filter-body">
        <div class="platform-filter-label">
          Transit Point
        </div>

        <div class="platform-filter-select">
          <app-searchable-select
                  [(ngModel)]="selectedWarehouseCode"
                  [options]="warehouseSelectOptions"
                  icon="fas fa-warehouse"
                  allOptionLabel="Tutte le piattaforme"
                  searchPlaceholder="Cerca piattaforma..."
                  (valueChange)="onWarehouseChange()">
          </app-searchable-select>
        </div>
      </div>
    </div>

    <div class="platform-filter" *ngIf="isSingleWarehouseUser">
      <div class="platform-filter-icon">
        <i class="fas fa-warehouse"></i>
      </div>
      <div class="platform-filter-body">
        <div class="platform-filter-label">Transit Point</div>
        <div class="platform-filter-locked" [title]="'Piattaforma assegnata: ' + selectedWarehouseName">
          <span class="platform-filter-name">{{ selectedWarehouseName }}</span>
          <i class="fas fa-lock ms-2"></i>
        </div>
      </div>
    </div>
  </div>

  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="showFilters = !showFilters"
                [title]="showFilters ? 'Comprimi' : 'Espandi'">
          <i class="fas" [ngClass]="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="showFilters">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Codice viaggio</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-route filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="searchTripCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice viaggio...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice collo</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="searchParcelCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice collo...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice documento di trasporto</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-file-lines filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="searchWaybillCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice DDT...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Piattaforma partenza</label>
          <app-searchable-select
                  [(ngModel)]="originWarehouseCode"
                  [options]="originWarehouseSelectOptions"
                  icon="fas fa-warehouse"
                  allOptionLabel="Tutte"
                  searchPlaceholder="Cerca piattaforma...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data partenza navetta da</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #shuttleDepartureDateFromInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleDepartureDateFromStr')"
                   (click)="openDatePicker('shuttleDepartureDateFromStr')"
                   (focus)="openDatePicker('shuttleDepartureDateFromStr')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleDepartureDateFromStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleDepartureDateFromStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleDepartureDateFromStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleDepartureDateFromStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data partenza navetta a</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #shuttleDepartureDateToInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleDepartureDateToStr')"
                   (click)="openDatePicker('shuttleDepartureDateToStr')"
                   (focus)="openDatePicker('shuttleDepartureDateToStr')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleDepartureDateToStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleDepartureDateToStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleDepartureDateToStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleDepartureDateToStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data arrivo navetta da</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #shuttleArrivalDateFromInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleArrivalDateFromStr')"
                   (click)="openDatePicker('shuttleArrivalDateFromStr')"
                   (focus)="openDatePicker('shuttleArrivalDateFromStr')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateFromStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleArrivalDateFromStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateFromStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleArrivalDateFromStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data arrivo navetta a</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #shuttleArrivalDateToInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleArrivalDateToStr')"
                   (click)="openDatePicker('shuttleArrivalDateToStr')"
                   (focus)="openDatePicker('shuttleArrivalDateToStr')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateToStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleArrivalDateToStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateToStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleArrivalDateToStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data picking da</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #pickingDateFromInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('pickingDateFromStr')"
                   (click)="openDatePicker('pickingDateFromStr')"
                   (focus)="openDatePicker('pickingDateFromStr')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('pickingDateFromStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('pickingDateFromStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('pickingDateFromStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('pickingDateFromStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data picking a</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #pickingDateToInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('pickingDateToStr')"
                   (click)="openDatePicker('pickingDateToStr')"
                   (focus)="openDatePicker('pickingDateToStr')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('pickingDateToStr', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('pickingDateToStr')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('pickingDateToStr', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('pickingDateToStr')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Stato</label>
          <div class="picking-status-filter-group">
            <button type="button" *ngFor="let st of pickingStatuses; trackBy: trackByStatus"
                    class="picking-status-filter-chip"
                    [ngClass]="'picking-status-filter-chip--' + getPickingStatusKey(st)"
                    [class.active]="isStatusFilterChecked(st)"
                    [matTooltip]="getPickingStatusTooltip(st)"
                    (click)="toggleStatusFilter(st)">
              <i class="fas" [ngClass]="isStatusFilterChecked(st) ? 'fa-check-circle' : 'fa-circle'"></i>
              {{ getPickingStatusPluralLabel(st) }}
            </button>
          </div>
        </div>
      </div>

      <div class="alert alert-warning picking-filter-validation-alert mt-3" *ngIf="filterValidationError">
        <i class="fas fa-triangle-exclamation me-2"></i>
        Imposta almeno uno tra: Codice viaggio, Codice collo, Codice documento di trasporto, Data partenza navetta da/a, Data arrivo navetta da/a oppure Data picking da/a prima di cercare.
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-language" (click)="resetFilters()">
          <i class="fas fa-rotate-left me-1"></i> Reset
        </button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">
          <i class="fas fa-magnifying-glass me-1"></i> Cerca
        </button>
      </div>
    </div>
  </div>

  <div id="summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Riepilogo</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleReportCollapsed()"
                [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isReportCollapsed">
      <div class="sm-metrics-grid">

        <div *ngFor="let st of pickingStatuses; trackBy: trackByStatus"
             class="sm-metric-card sm-metric-card--clickable"
             [class.disabled]="getSummaryCount(st) === 0"
             (click)="getSummaryCount(st) > 0 && openStatusListPopup(st)"
             [matTooltip]="getPickingStatusTooltip(st) + ' - clicca per vedere l\'elenco'">
          <div class="sm-metric-icon" [ngClass]="getPickingStatusMetricIconClass(st)">
            <i [ngClass]="getPickingStatusIcon(st)"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ getSummaryCount(st) | number }}</ng-container>
            </div>
            <div class="sm-metric-label">{{ getPickingStatusPluralLabel(st) }}</div>
          </div>
          <div class="picking-summary-ring" *ngIf="!isLoading && st === 'EXECUTED'">
            <ng-container *ngTemplateOutlet="progressRing; context: { executed: summary.totalExecuted, total: summaryTotal }"></ng-container>
          </div>
        </div>

        <div class="sm-metric-card sm-metric-card--total sm-metric-card--clickable"
             [class.disabled]="summaryTotal === 0"
             (click)="summaryTotal > 0 && openStatusListPopup('ALL')"
             matTooltip="Vedi l'elenco di tutti i colli">
          <div class="sm-metric-icon sm-metric-icon--blue">
            <i class="fas fa-boxes-stacked"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ summaryTotal | number }}</ng-container>
            </div>
            <div class="sm-metric-label">Totale</div>
          </div>
        </div>

        <!-- Card "Pickerati senza affido" nascosta su richiesta - da ripristinare rimuovendo questo commento
        <div class="picking-summary-separate">
          <div class="sm-metric-card sm-metric-card--clickable"
               [class.disabled]="summary.totalOrphans === 0"
               (click)="summary.totalOrphans > 0 && openOrphansListPopup()"
               matTooltip="Vedi l'elenco dei colli pickerati senza affido">
            <div class="sm-metric-icon sm-metric-icon--purple">
              <i class="fas fa-question"></i>
            </div>
            <div class="sm-metric-body">
              <div class="sm-metric-value">
                <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
                <ng-container *ngIf="!isLoading">{{ summary.totalOrphans | number }}</ng-container>
              </div>
              <div class="sm-metric-label">Pickerati senza affido</div>
            </div>
          </div>
          <div class="picking-summary-separate-caption">
            <i class="fas fa-circle-exclamation me-1"></i>
            Non incluso nel Totale
          </div>
        </div>
        -->

      </div>
    </div>
  </div>

  <div id="picking-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="header-title">
          <i class="fas fa-route header-icon"></i>
          <h3>{{ showPlatformGrouping ? 'Piattaforme' : 'Viaggi' }}</h3>
        </div>

        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-sm pagination-reset-btn"
                  [ngClass]="hasActiveTableFiltersOrSort() ? 'btn-outline-primary' : 'btn-outline-secondary'"
                  [disabled]="!hasActiveTableFiltersOrSort()"
                  (click)="resetTableFiltersAndSort()"
                  title="Azzera filtri e ordinamenti della tabella">
            <i class="fas fa-filter-circle-xmark"></i>
          </button>

          <div class="btn-group btn-group-sm pagination-selector" role="group" aria-label="Elementi per pagina">
            <button type="button" class="btn"
                    *ngFor="let size of pageSizeOptions"
                    [ngClass]="itemsPerPage === size ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(size)"
                    [title]="size + ' elementi per pagina'">
              {{ size }}
            </button>
          </div>

          <span class="badge bg-light text-muted" title="Totale righe">
            <i class="fas fa-list me-1"></i> {{ totalRecords | number }}
          </span>
        </div>
      </div>
    </div>

    <div class="card-body p-0">

      <div class="text-center py-5" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div class="empty-state" *ngIf="!isLoading && groups.length === 0">
        <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
        Nessun dato trovato con i filtri selezionati
      </div>

      <!-- Livello 1: PIATTAFORMA (solo se multi-magazzino e nessuna piattaforma selezionata) -->
      <div class="table-responsive" *ngIf="!isLoading && groups.length > 0">
        <table class="table rt-table wm-grouped-table mb-0">
          <thead *ngIf="showPlatformGrouping">
          <tr>
            <th class="rt-expand-th text-center"></th>
            <th class="sortable-th" (click)="setTopSort('warehouseName')">
              <div class="wm-th-content">
                Piattaforma
                <i class="fas" [ngClass]="getTopSortIcon('warehouseName')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('platform')"
                   (click)="toggleTopFilterPopover('platform', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'platform'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="platformFilter" placeholder="Filtra per piattaforma..."
                         (keyup.enter)="applyTopFilterPopover()" (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="platformValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTopValuesChecked('platform')" (change)="toggleAllTopValues('platform')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getPlatformValueOptions()">
                      <input type="checkbox" [checked]="isTopValueChecked('platform', v)" (change)="toggleTopValue('platform', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getPlatformValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('platform')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('prePlannedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pre-pickerabili
                <i class="fas" [ngClass]="getTopSortIcon('prePlannedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('plannedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pickerabili
                <i class="fas" [ngClass]="getTopSortIcon('plannedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('executedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pickerati
                <i class="fas" [ngClass]="getTopSortIcon('executedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('executedPercent')">
              <div class="wm-th-content wm-th-content--center">
                Percentuale Pickerati
                <i class="fas" [ngClass]="getTopSortIcon('executedPercent')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('unknownUncertainCount')">
              <div class="wm-th-content wm-th-content--center">
                Non Pickerati Incerti
                <i class="fas" [ngClass]="getTopSortIcon('unknownUncertainCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('unknownDefinitiveCount')">
              <div class="wm-th-content wm-th-content--center">
                Non Pickerati Definitivi
                <i class="fas" [ngClass]="getTopSortIcon('unknownDefinitiveCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('totalCount')">
              <div class="wm-th-content wm-th-content--center">
                Totale
                <i class="fas" [ngClass]="getTopSortIcon('totalCount')"></i>
              </div>
            </th>
            <!-- Colonna "Senza affido" nascosta su richiesta - da ripristinare rimuovendo questo commento
            <th class="text-center sortable-th" (click)="setTopSort('orphanCount')">
              <div class="wm-th-content wm-th-content--center">
                Senza affido
                <i class="fas" [ngClass]="getTopSortIcon('orphanCount')"></i>
              </div>
            </th>
            -->
          </tr>
          </thead>

          <thead *ngIf="!showPlatformGrouping">
          <tr>
            <th class="rt-expand-th text-center"></th>
            <th class="sortable-th" (click)="setTopSort('tripCode')">
              <div class="wm-th-content">
                Viaggio
                <i class="fas" [ngClass]="getTopSortIcon('tripCode')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('trip')"
                   (click)="toggleTopFilterPopover('trip', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'trip'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="tripCodeFilter" placeholder="Filtra per codice viaggio..."
                         (keyup.enter)="applyTopFilterPopover()" (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="tripValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTopValuesChecked('trip')" (change)="toggleAllTopValues('trip')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getTripValueOptions()">
                      <input type="checkbox" [checked]="isTopValueChecked('trip', v)" (change)="toggleTopValue('trip', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getTripValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('trip')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setTopSort('carrier')">
              <div class="wm-th-content">
                Vettore
                <i class="fas" [ngClass]="getTopSortIcon('carrier')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('carrier')"
                   (click)="toggleTopFilterPopover('carrier', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'carrier'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="carrierFilter" placeholder="Filtra per vettore..."
                         (keyup.enter)="applyTopFilterPopover()" (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="carrierValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTopValuesChecked('carrier')" (change)="toggleAllTopValues('carrier')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getCarrierValueOptions()">
                      <input type="checkbox" [checked]="isTopValueChecked('carrier', v)" (change)="toggleTopValue('carrier', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getCarrierValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('carrier')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setTopSort('plate')">
              <div class="wm-th-content">
                Targa
                <i class="fas" [ngClass]="getTopSortIcon('plate')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('plate')"
                   (click)="toggleTopFilterPopover('plate', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'plate'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="plateFilter" placeholder="Filtra per targa..."
                         (keyup.enter)="applyTopFilterPopover()" (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="plateValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTopValuesChecked('plate')" (change)="toggleAllTopValues('plate')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getPlateValueOptions()">
                      <input type="checkbox" [checked]="isTopValueChecked('plate', v)" (change)="toggleTopValue('plate', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getPlateValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('plate')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>

            <th class="sortable-th" (click)="setTopSort('tripOriginWarehouses')">
              <div class="wm-th-content">
                Magazzino Partenza
                <i class="fas" [ngClass]="getTopSortIcon('tripOriginWarehouses')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTripOriginFilterActive()"
                   (click)="toggleTopFilterPopover('tripOrigin', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'tripOrigin'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="tripOriginFilter" placeholder="Filtra per magazzino..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="tripOriginValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTripOriginValuesChecked()" (change)="toggleAllTripOriginValues()">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getTripOriginValueOptions()">
                      <input type="checkbox" [checked]="isTripOriginValueChecked(v)" (change)="toggleTripOriginValue(v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getTripOriginValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTripOriginFilter(); applyTopFilterPopover()">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setTopSort('tripShuttleArrivalDate')">
              <div class="wm-th-content">
                Data Arrivo
                <i class="fas" [ngClass]="getTopSortIcon('tripShuttleArrivalDate')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTripArrivalFilterActive()"
                   (click)="toggleTopFilterPopover('tripArrival', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'tripArrival'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="tripArrivalFilter" placeholder="Filtra per data..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="tripArrivalValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTripArrivalValuesChecked()" (change)="toggleAllTripArrivalValues()">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getTripArrivalValueOptions()">
                      <input type="checkbox" [checked]="isTripArrivalValueChecked(v)" (change)="toggleTripArrivalValue(v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getTripArrivalValueOptions().length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTripArrivalFilter(); applyTopFilterPopover()">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('prePlannedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pre-pickerabili
                <i class="fas" [ngClass]="getTopSortIcon('prePlannedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('plannedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pickerabili
                <i class="fas" [ngClass]="getTopSortIcon('plannedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('executedCount')">
              <div class="wm-th-content wm-th-content--center">
                Pickerati
                <i class="fas" [ngClass]="getTopSortIcon('executedCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('executedPercent')">
              <div class="wm-th-content wm-th-content--center">
                Percentuale Pickerati
                <i class="fas" [ngClass]="getTopSortIcon('executedPercent')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('unknownUncertainCount')">
              <div class="wm-th-content wm-th-content--center">
                Non Pickerati Incerti
                <i class="fas" [ngClass]="getTopSortIcon('unknownUncertainCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('unknownDefinitiveCount')">
              <div class="wm-th-content wm-th-content--center">
                Non Pickerati Definitivi
                <i class="fas" [ngClass]="getTopSortIcon('unknownDefinitiveCount')"></i>
              </div>
            </th>
            <th class="text-center sortable-th" (click)="setTopSort('totalCount')">
              <div class="wm-th-content wm-th-content--center">
                Totale
                <i class="fas" [ngClass]="getTopSortIcon('totalCount')"></i>
              </div>
            </th>
          </tr>
          </thead>

          <tbody>

          <ng-container *ngFor="let wgroup of groups; trackBy: trackByWarehouseCode">

            <!-- riga PIATTAFORMA -->
            <ng-container *ngIf="showPlatformGrouping">
              <tr class="rt-row wm-waybill-row"
                  [class.expanded]="isWarehouseExpanded(wgroup.warehouseCode)"
                  (click)="toggleWarehouseExpand(wgroup.warehouseCode)">
                <td class="text-center wm-expand-cell">
                  <button type="button" class="wm-expand-btn"
                          [class.is-expanded]="isWarehouseExpanded(wgroup.warehouseCode)">
                    <i class="fas" [ngClass]="isWarehouseExpanded(wgroup.warehouseCode) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                  </button>
                </td>
                <td class="fw-medium">
                  <div class="d-flex align-items-center gap-1">
                    <i class="fas fa-warehouse me-2 text-muted"></i>
                    <span class="rt-strong picking-cell-truncate" [matTooltip]="wgroup.warehouseName">{{ wgroup.warehouseName }}</span>
                    <i class="fas fa-copy copy-icon" (click)="$event.stopPropagation(); copyToClipboard(wgroup.warehouseName, 'piattaforma')"
                       matTooltip="Copia nome piattaforma"></i>
                  </div>
                </td>
                <td class="text-center"><span class="picking-badge picking-badge--preplanned">{{ wgroup.prePlannedCount || 0 }}</span></td>
                <td class="text-center"><span class="picking-badge picking-badge--planned">{{ wgroup.plannedCount || 0 }}</span></td>
                <td class="text-center"><span class="picking-badge picking-badge--executed">{{ wgroup.executedCount || 0 }}</span></td>
                <td class="text-center">
                  <ng-container *ngTemplateOutlet="progressRing; context: { executed: wgroup.executedCount, total: wgroup.totalCount }"></ng-container>
                </td>
                <td class="text-center"><span class="picking-badge picking-badge--uncertain">{{ wgroup.unknownUncertainCount || 0 }}</span></td>
                <td class="text-center"><span class="picking-badge picking-badge--definitive">{{ wgroup.unknownDefinitiveCount || 0 }}</span></td>
                <td class="text-center"><span class="fw-semibold">{{ wgroup.totalCount }}</span></td>
                <!-- Cella "Senza affido" nascosta su richiesta - da ripristinare rimuovendo questo commento
                <td class="text-center"><span class="picking-badge picking-badge--orphan">{{ wgroup.orphanCount }}</span></td>
                -->
              </tr>
            </ng-container>

            <!-- Livello 2: VIAGGI di questa piattaforma (visibili sempre se non c'e' raggruppamento piattaforma, altrimenti solo se la piattaforma e' espansa) -->
            <ng-container *ngIf="!showPlatformGrouping || isWarehouseExpanded(wgroup.warehouseCode)">

              <tr class="wm-parcels-subheader" *ngIf="showPlatformGrouping">
                <td></td>
                <td colspan="8">

                  <div class="picking-nested-scroll">
                  <table class="table table-sm wm-subtable mb-0 picking-trip-table">
                    <thead>
                    <tr>
                      <th class="rt-expand-th text-center"></th>
                      <th class="sortable-th" (click)="setTopSort('tripCode')">
                        <div class="wm-th-content">
                          Viaggio
                          <i class="fas" [ngClass]="getTopSortIcon('tripCode')"></i>
                          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('trip')"
                             (click)="toggleTopFilterPopover('trip-nested', $event)"></i>
                          <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'trip-nested'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                            <input type="text" [(ngModel)]="tripCodeFilter" placeholder="Filtra per codice viaggio..."
                                   (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="tripValueSearch" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllTopValuesChecked('trip')" (change)="toggleAllTopValues('trip')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getTripValueOptions()">
                      <input type="checkbox" [checked]="isTopValueChecked('trip', v)" (change)="toggleTopValue('trip', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getTripValueOptions().length === 0">Nessun valore</div>
                  </div>
                            <div class="wm-col-filter-popover-actions">
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('trip')">Pulisci</button>
                              <button type="button" class="btn btn-sm btn-primary" (click)="closeTopFilterPopover()">Applica</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-th" (click)="setTopSort('carrier')">
                        <div class="wm-th-content">
                          Vettore
                          <i class="fas" [ngClass]="getTopSortIcon('carrier')"></i>
                          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('carrier')"
                             (click)="toggleTopFilterPopover('carrier-nested', $event)"></i>
                          <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'carrier-nested'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                            <input type="text" [(ngModel)]="carrierFilter" placeholder="Filtra per vettore..."
                                   (click)="$event.stopPropagation()">
                            <div class="wm-col-filter-divider"></div>
                            <div class="wm-col-filter-section-label">Valori</div>
                            <div class="wm-col-filter-value-search">
                              <input type="text" [(ngModel)]="carrierValueSearch" placeholder="Cerca valore...">
                            </div>
                            <div class="wm-col-filter-value-list">
                              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                                <input type="checkbox" [checked]="areAllTopValuesChecked('carrier')" (change)="toggleAllTopValues('carrier')">
                                Seleziona tutto
                              </label>
                              <label class="wm-col-filter-value-item" *ngFor="let v of getCarrierValueOptions()">
                                <input type="checkbox" [checked]="isTopValueChecked('carrier', v)" (change)="toggleTopValue('carrier', v)">
                                {{ v }}
                              </label>
                              <div class="wm-col-filter-value-empty" *ngIf="getCarrierValueOptions().length === 0">Nessun valore</div>
                            </div>
                            <div class="wm-col-filter-popover-actions">
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('carrier')">Pulisci</button>
                              <button type="button" class="btn btn-sm btn-primary" (click)="closeTopFilterPopover()">Applica</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-th" (click)="setTopSort('plate')">
                        <div class="wm-th-content">
                          Targa
                          <i class="fas" [ngClass]="getTopSortIcon('plate')"></i>
                          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTopFilterActive('plate')"
                             (click)="toggleTopFilterPopover('plate-nested', $event)"></i>
                          <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'plate-nested'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                            <input type="text" [(ngModel)]="plateFilter" placeholder="Filtra per targa..."
                                   (click)="$event.stopPropagation()">
                            <div class="wm-col-filter-divider"></div>
                            <div class="wm-col-filter-section-label">Valori</div>
                            <div class="wm-col-filter-value-search">
                              <input type="text" [(ngModel)]="plateValueSearch" placeholder="Cerca valore...">
                            </div>
                            <div class="wm-col-filter-value-list">
                              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                                <input type="checkbox" [checked]="areAllTopValuesChecked('plate')" (change)="toggleAllTopValues('plate')">
                                Seleziona tutto
                              </label>
                              <label class="wm-col-filter-value-item" *ngFor="let v of getPlateValueOptions()">
                                <input type="checkbox" [checked]="isTopValueChecked('plate', v)" (change)="toggleTopValue('plate', v)">
                                {{ v }}
                              </label>
                              <div class="wm-col-filter-value-empty" *ngIf="getPlateValueOptions().length === 0">Nessun valore</div>
                            </div>
                            <div class="wm-col-filter-popover-actions">
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTopFilter('plate')">Pulisci</button>
                              <button type="button" class="btn btn-sm btn-primary" (click)="closeTopFilterPopover()">Applica</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-th" (click)="setTopSort('tripOriginWarehouses')">
                        <div class="wm-th-content">
                          Magazzino Partenza
                          <i class="fas" [ngClass]="getTopSortIcon('tripOriginWarehouses')"></i>
                          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTripOriginFilterActive()"
                             (click)="toggleTopFilterPopover('tripOrigin', $event)"></i>
                          <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'tripOrigin'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                            <input type="text" [(ngModel)]="tripOriginFilter" placeholder="Filtra per magazzino..." (click)="$event.stopPropagation()">
                            <div class="wm-col-filter-divider"></div>
                            <div class="wm-col-filter-section-label">Valori</div>
                            <div class="wm-col-filter-value-search">
                              <input type="text" [(ngModel)]="tripOriginValueSearch" placeholder="Cerca valore...">
                            </div>
                            <div class="wm-col-filter-value-list">
                              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                                <input type="checkbox" [checked]="areAllTripOriginValuesChecked()" (change)="toggleAllTripOriginValues()">
                                Seleziona tutto
                              </label>
                              <label class="wm-col-filter-value-item" *ngFor="let v of getTripOriginValueOptions()">
                                <input type="checkbox" [checked]="isTripOriginValueChecked(v)" (change)="toggleTripOriginValue(v)">
                                {{ v }}
                              </label>
                              <div class="wm-col-filter-value-empty" *ngIf="getTripOriginValueOptions().length === 0">Nessun valore</div>
                            </div>
                            <div class="wm-col-filter-popover-actions">
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTripOriginFilter(); applyTopFilterPopover()">Pulisci</button>
                              <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-th" (click)="setTopSort('tripShuttleArrivalDate')">
                        <div class="wm-th-content">
                          Data Arrivo
                          <i class="fas" [ngClass]="getTopSortIcon('tripShuttleArrivalDate')"></i>
                          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isTripArrivalFilterActive()"
                             (click)="toggleTopFilterPopover('tripArrival', $event)"></i>
                          <div class="wm-col-filter-popover" *ngIf="openTopFilterKey === 'tripArrival'" [style.top]="topFilterPopoverStyle.top" [style.left]="topFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                            <input type="text" [(ngModel)]="tripArrivalFilter" placeholder="Filtra per data..." (click)="$event.stopPropagation()">
                            <div class="wm-col-filter-divider"></div>
                            <div class="wm-col-filter-section-label">Valori</div>
                            <div class="wm-col-filter-value-search">
                              <input type="text" [(ngModel)]="tripArrivalValueSearch" placeholder="Cerca valore...">
                            </div>
                            <div class="wm-col-filter-value-list">
                              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                                <input type="checkbox" [checked]="areAllTripArrivalValuesChecked()" (change)="toggleAllTripArrivalValues()">
                                Seleziona tutto
                              </label>
                              <label class="wm-col-filter-value-item" *ngFor="let v of getTripArrivalValueOptions()">
                                <input type="checkbox" [checked]="isTripArrivalValueChecked(v)" (change)="toggleTripArrivalValue(v)">
                                {{ v }}
                              </label>
                              <div class="wm-col-filter-value-empty" *ngIf="getTripArrivalValueOptions().length === 0">Nessun valore</div>
                            </div>
                            <div class="wm-col-filter-popover-actions">
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearTripArrivalFilter(); applyTopFilterPopover()">Pulisci</button>
                              <button type="button" class="btn btn-sm btn-primary" (click)="applyTopFilterPopover()">Applica</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('prePlannedCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Pre-pickerabili
                          <i class="fas" [ngClass]="getTopSortIcon('prePlannedCount')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('plannedCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Pickerabili
                          <i class="fas" [ngClass]="getTopSortIcon('plannedCount')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('executedCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Pickerati
                          <i class="fas" [ngClass]="getTopSortIcon('executedCount')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('executedPercent')">
                        <div class="wm-th-content wm-th-content--center">
                          Percentuale Pickerati
                          <i class="fas" [ngClass]="getTopSortIcon('executedPercent')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('unknownUncertainCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Non Pickerati Incerti
                          <i class="fas" [ngClass]="getTopSortIcon('unknownUncertainCount')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('unknownDefinitiveCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Non Pickerati Definitivi
                          <i class="fas" [ngClass]="getTopSortIcon('unknownDefinitiveCount')"></i>
                        </div>
                      </th>
                      <th class="text-center sortable-th" (click)="setTopSort('totalCount')">
                        <div class="wm-th-content wm-th-content--center">
                          Totale
                          <i class="fas" [ngClass]="getTopSortIcon('totalCount')"></i>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let trip of getFilteredSortedTrips(wgroup.trips); trackBy: trackByTripCode">
                        <tr class="wm-parcel-subrow picking-trip-row"
                            [class.expanded]="isTripExpanded(wgroup.warehouseCode, trip)"
                            (click)="toggleTripExpand(wgroup.warehouseCode, trip)">
                          <td class="text-center wm-expand-cell">
                            <button type="button" class="wm-expand-btn"
                                    [class.is-expanded]="isTripExpanded(wgroup.warehouseCode, trip)">
                              <i class="fas" [ngClass]="isTripExpanded(wgroup.warehouseCode, trip) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                            </button>
                          </td>
                          <td class="rt-strong">
                            <div class="d-flex align-items-center gap-1">
                              <span *ngIf="trip.tripId; else noTripCode">{{ trip.tripCode }}</span>
                              <ng-template #noTripCode><span class="text-muted fst-italic">Senza viaggio assegnato</span></ng-template>
                              <i class="fas fa-copy copy-icon" *ngIf="trip.tripId" (click)="$event.stopPropagation(); copyToClipboard(trip.tripCode, 'viaggio')"
                                 matTooltip="Copia codice viaggio"></i>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex align-items-center gap-1">
                              <span class="picking-cell-truncate" [matTooltip]="trip.tripCarrierName || ''">{{ trip.tripCarrierName || '-' }}</span>
                              <i class="fas fa-copy copy-icon" *ngIf="trip.tripCarrierName" (click)="$event.stopPropagation(); copyToClipboard(trip.tripCarrierName, 'vettore')"
                                 matTooltip="Copia vettore"></i>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex align-items-center gap-1">
                              <span class="picking-cell-truncate" [matTooltip]="trip.tripPlateNo || ''">{{ trip.tripPlateNo || '-' }}</span>
                              <i class="fas fa-copy copy-icon" *ngIf="trip.tripPlateNo" (click)="$event.stopPropagation(); copyToClipboard(trip.tripPlateNo, 'targa')"
                                 matTooltip="Copia targa"></i>
                            </div>
                          </td>
                          <td class="picking-origin-warehouses">
                            <div class="d-flex align-items-center gap-1">
                              <span class="picking-cell-truncate" *ngIf="trip.tripOriginWarehouses; else noOriginWh"
                                    [matTooltip]="trip.tripOriginWarehouses.split(';').join(', ')">{{ trip.tripOriginWarehouses.split(';').join(', ') }}</span>
                              <ng-template #noOriginWh><span class="text-muted">-</span></ng-template>
                              <i class="fas fa-copy copy-icon" *ngIf="trip.tripOriginWarehouses" (click)="$event.stopPropagation(); copyToClipboard(trip.tripOriginWarehouses.split(';').join(', '), 'magazzino partenza')"
                                 matTooltip="Copia magazzini partenza"></i>
                            </div>
                          </td>
                          <td class="rt-date">
                            <span *ngIf="trip.tripShuttleArrivalDate; else noShuttleArr">{{ formatDateTime(trip.tripShuttleArrivalDate) }}</span>
                            <ng-template #noShuttleArr><span class="text-muted">-</span></ng-template>
                          </td>
                          <td class="text-center"><span class="picking-badge picking-badge--preplanned">{{ trip.prePlannedCount || 0 }}</span></td>
                          <td class="text-center"><span class="picking-badge picking-badge--planned">{{ trip.plannedCount || 0 }}</span></td>
                          <td class="text-center"><span class="picking-badge picking-badge--executed">{{ trip.executedCount || 0 }}</span></td>
                          <td class="text-center">
                            <ng-container *ngTemplateOutlet="progressRing; context: { executed: trip.executedCount, total: trip.totalCount }"></ng-container>
                          </td>
                          <td class="text-center"><span class="picking-badge picking-badge--uncertain">{{ trip.unknownUncertainCount || 0 }}</span></td>
                          <td class="text-center"><span class="picking-badge picking-badge--definitive">{{ trip.unknownDefinitiveCount || 0 }}</span></td>
                          <td class="text-center"><span class="fw-semibold">{{ trip.totalCount }}</span></td>
                        </tr>

                        <tr class="picking-parcels-row" *ngIf="isTripExpanded(wgroup.warehouseCode, trip)">
                          <td colspan="13">
                            <ng-container *ngTemplateOutlet="loadingListsTable; context: { loadingLists: trip.loadingLists, warehouseCode: wgroup.warehouseCode, trip: trip }"></ng-container>
                          </td>
                        </tr>
                      </ng-container>

                      <tr *ngIf="wgroup.trips.length === 0">
                        <td colspan="13" class="text-center text-muted py-3">Nessun viaggio trovato per questa piattaforma</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>

                </td>
              </tr>

              <!-- caso senza raggruppamento piattaforma: i viaggi sono righe di primo livello -->
              <ng-container *ngIf="!showPlatformGrouping">
                <ng-container *ngFor="let trip of wgroup.trips; trackBy: trackByTripCode">
                  <tr class="rt-row wm-waybill-row"
                      [class.expanded]="isTripExpanded(wgroup.warehouseCode, trip)"
                      (click)="toggleTripExpand(wgroup.warehouseCode, trip)">
                    <td class="text-center wm-expand-cell">
                      <button type="button" class="wm-expand-btn"
                              [class.is-expanded]="isTripExpanded(wgroup.warehouseCode, trip)">
                        <i class="fas" [ngClass]="isTripExpanded(wgroup.warehouseCode, trip) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                      </button>
                    </td>
                    <td class="fw-medium rt-strong">
                      <div class="d-flex align-items-center gap-1">
                        <span *ngIf="trip.tripId; else noTripCode2">{{ trip.tripCode }}</span>
                        <ng-template #noTripCode2><span class="text-muted fst-italic">Senza viaggio assegnato</span></ng-template>
                        <i class="fas fa-copy copy-icon" *ngIf="trip.tripId" (click)="$event.stopPropagation(); copyToClipboard(trip.tripCode, 'viaggio')"
                           matTooltip="Copia codice viaggio"></i>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center gap-1">
                        <span class="picking-cell-truncate" [matTooltip]="trip.tripCarrierName || ''">{{ trip.tripCarrierName || '-' }}</span>
                        <i class="fas fa-copy copy-icon" *ngIf="trip.tripCarrierName" (click)="$event.stopPropagation(); copyToClipboard(trip.tripCarrierName, 'vettore')"
                           matTooltip="Copia vettore"></i>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center gap-1">
                        <span class="picking-cell-truncate" [matTooltip]="trip.tripPlateNo || ''">{{ trip.tripPlateNo || '-' }}</span>
                        <i class="fas fa-copy copy-icon" *ngIf="trip.tripPlateNo" (click)="$event.stopPropagation(); copyToClipboard(trip.tripPlateNo, 'targa')"
                           matTooltip="Copia targa"></i>
                      </div>
                    </td>
                    <td class="picking-origin-warehouses">
                      <div class="d-flex align-items-center gap-1">
                        <span class="picking-cell-truncate" *ngIf="trip.tripOriginWarehouses; else noOriginWh2"
                              [matTooltip]="trip.tripOriginWarehouses.split(';').join(', ')">{{ trip.tripOriginWarehouses.split(';').join(', ') }}</span>
                        <ng-template #noOriginWh2><span class="text-muted">-</span></ng-template>
                        <i class="fas fa-copy copy-icon" *ngIf="trip.tripOriginWarehouses" (click)="$event.stopPropagation(); copyToClipboard(trip.tripOriginWarehouses.split(';').join(', '), 'magazzino partenza')"
                           matTooltip="Copia magazzini partenza"></i>
                      </div>
                    </td>
                    <td class="rt-date">
                      <span *ngIf="trip.tripShuttleArrivalDate; else noShuttleArr2">{{ formatDateTime(trip.tripShuttleArrivalDate) }}</span>
                      <ng-template #noShuttleArr2><span class="text-muted">-</span></ng-template>
                    </td>
                    <td class="text-center"><span class="picking-badge picking-badge--preplanned">{{ trip.prePlannedCount || 0 }}</span></td>
                    <td class="text-center"><span class="picking-badge picking-badge--planned">{{ trip.plannedCount || 0 }}</span></td>
                    <td class="text-center"><span class="picking-badge picking-badge--executed">{{ trip.executedCount || 0 }}</span></td>
                    <td class="text-center">
                      <ng-container *ngTemplateOutlet="progressRing; context: { executed: trip.executedCount, total: trip.totalCount }"></ng-container>
                    </td>
                    <td class="text-center"><span class="picking-badge picking-badge--uncertain">{{ trip.unknownUncertainCount || 0 }}</span></td>
                    <td class="text-center"><span class="picking-badge picking-badge--definitive">{{ trip.unknownDefinitiveCount || 0 }}</span></td>
                    <td class="text-center"><span class="fw-semibold">{{ trip.totalCount }}</span></td>
                  </tr>

                  <tr class="wm-parcels-subheader" *ngIf="isTripExpanded(wgroup.warehouseCode, trip)">
                    <td></td>
                    <td colspan="12">
                      <ng-container *ngTemplateOutlet="loadingListsTable; context: { loadingLists: trip.loadingLists, warehouseCode: wgroup.warehouseCode, trip: trip }"></ng-container>
                    </td>
                  </tr>
                </ng-container>

                <tr *ngIf="wgroup.trips.length === 0">
                  <td colspan="13" class="text-center text-muted py-4">Nessun viaggio trovato</td>
                </tr>
              </ng-container>

            </ng-container>

          </ng-container>

          </tbody>
        </table>
      </div>

      <div class="pagination-container" *ngIf="!isLoading && totalRecords > 0">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber"
                    class="pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                    [attr.aria-label]="'Pagina ' + page"
                    [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalRecords }}
          </span>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === getTotalPages()" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- Template riutilizzabile: anello di progresso pickerati/totale -->
<ng-template #progressRing let-executed="executed" let-total="total">
  <div class="picking-progress-ring"
       [style.--pct.%]="getPickingPercent(executed, total)"
       [matTooltip]="executed + ' pickerati su ' + total + ' (' + getPickingPercent(executed, total) + '%)'">
    <span class="picking-progress-ring-label">{{ getPickingPercent(executed, total) }}%</span>
  </div>
</ng-template>

<!-- Template riutilizzabile: sotto-tabella dei borderò di un viaggio -->
<ng-template #loadingListsTable let-loadingLists="loadingLists" let-warehouseCode="warehouseCode" let-trip="trip">
  <div class="picking-nested-scroll">
  <table class="table table-sm wm-subtable mb-0 picking-loading-list-table">
    <thead>
    <tr>
      <th class="rt-expand-th text-center"></th>
      <th>Borderò</th>
      <th class="text-center sortable-th" (click)="setLoadingListSort('direction')">
        <div class="wm-th-content wm-th-content--center">
          Direzione
          <i class="fas" [ngClass]="getLoadingListSortIcon('direction')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isLoadingListFilterActive('direction')"
             (click)="toggleLoadingListFilterPopover('direction', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openLoadingListFilterKey === 'direction'" [style.top]="loadingListFilterPopoverStyle.top" [style.left]="loadingListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="loadingListColumnFilters['direction']" placeholder="Filtra per direzione..." (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="loadingListValueSearch['direction']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllLoadingListValuesChecked(loadingLists, 'direction')" (change)="toggleAllLoadingListValues(loadingLists, 'direction')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getLoadingListValueOptions(loadingLists, 'direction')">
                <input type="checkbox" [checked]="isLoadingListValueChecked('direction', v)" (change)="toggleLoadingListValue('direction', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getLoadingListValueOptions(loadingLists, 'direction').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearLoadingListFilter('direction')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeLoadingListFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setLoadingListSort('loadingListTourGroups')">
        <div class="wm-th-content">
          Tour
          <i class="fas" [ngClass]="getLoadingListSortIcon('loadingListTourGroups')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isLoadingListFilterActive('loadingListTourGroups')"
             (click)="toggleLoadingListFilterPopover('loadingListTourGroups', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openLoadingListFilterKey === 'loadingListTourGroups'" [style.top]="loadingListFilterPopoverStyle.top" [style.left]="loadingListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="loadingListColumnFilters['loadingListTourGroups']" placeholder="Filtra per tour..." (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="loadingListValueSearch['loadingListTourGroups']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllLoadingListValuesChecked(loadingLists, 'loadingListTourGroups')" (change)="toggleAllLoadingListValues(loadingLists, 'loadingListTourGroups')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getLoadingListValueOptions(loadingLists, 'loadingListTourGroups')">
                <input type="checkbox" [checked]="isLoadingListValueChecked('loadingListTourGroups', v)" (change)="toggleLoadingListValue('loadingListTourGroups', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getLoadingListValueOptions(loadingLists, 'loadingListTourGroups').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearLoadingListFilter('loadingListTourGroups')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeLoadingListFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="text-center">Pre-pickerabili</th>
      <th class="text-center">Pickerabili</th>
      <th class="text-center">Pickerati</th>
      <th class="text-center">Percentuale Pickerati</th>
      <th class="text-center">Non Pickerati Incerti</th>
      <th class="text-center">Non Pickerati Definitivi</th>
      <th class="text-center">Totale</th>
    </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let ll of getFilteredSortedLoadingLists(loadingLists); trackBy: trackByLoadingListCode">
        <tr class="wm-parcel-subrow picking-loading-list-row"
            [class.expanded]="isLoadingListExpanded(warehouseCode, trip, ll)"
            (click)="toggleLoadingListExpand(warehouseCode, trip, ll)">
          <td class="text-center wm-expand-cell">
            <button type="button" class="wm-expand-btn"
                    [class.is-expanded]="isLoadingListExpanded(warehouseCode, trip, ll)">
              <i class="fas" [ngClass]="isLoadingListExpanded(warehouseCode, trip, ll) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            </button>
          </td>
          <td class="rt-strong">
            <div class="d-flex align-items-center gap-1">
              <span *ngIf="ll.loadingListId; else noLoadingListCode">{{ ll.loadingListCode }}</span>
              <ng-template #noLoadingListCode><span class="text-muted fst-italic">Senza borderò assegnato</span></ng-template>
              <i class="fas fa-copy copy-icon" *ngIf="ll.loadingListId" (click)="$event.stopPropagation(); copyToClipboard(ll.loadingListCode, 'borderò')"
                 matTooltip="Copia codice borderò"></i>
            </div>
          </td>
          <td class="text-center">
            <span class="picking-direction-badge"
                  [class.picking-direction-badge--departure]="ll.direction === 'DEPARTURE'"
                  [class.picking-direction-badge--arrival]="ll.direction === 'ARRIVAL'">
              {{ getLoadingListDirectionLabel(ll) }}
            </span>
          </td>
          <td>
            <div class="d-flex align-items-center gap-1">
              <span class="picking-cell-truncate" *ngIf="ll.loadingListTourGroups; else noTour" [matTooltip]="ll.loadingListTourGroups">{{ ll.loadingListTourGroups }}</span>
              <ng-template #noTour><span class="text-muted">-</span></ng-template>
              <i class="fas fa-copy copy-icon" *ngIf="ll.loadingListTourGroups" (click)="$event.stopPropagation(); copyToClipboard(ll.loadingListTourGroups, 'tour')"
                 matTooltip="Copia tour"></i>
            </div>
          </td>
          <td class="text-center"><span class="picking-badge picking-badge--preplanned">{{ ll.prePlannedCount || 0 }}</span></td>
          <td class="text-center"><span class="picking-badge picking-badge--planned">{{ ll.plannedCount || 0 }}</span></td>
          <td class="text-center"><span class="picking-badge picking-badge--executed">{{ ll.executedCount || 0 }}</span></td>
          <td class="text-center">
            <ng-container *ngTemplateOutlet="progressRing; context: { executed: ll.executedCount, total: ll.totalCount }"></ng-container>
          </td>
          <td class="text-center"><span class="picking-badge picking-badge--uncertain">{{ ll.unknownUncertainCount || 0 }}</span></td>
          <td class="text-center"><span class="picking-badge picking-badge--definitive">{{ ll.unknownDefinitiveCount || 0 }}</span></td>
          <td class="text-center"><span class="fw-semibold">{{ ll.totalCount }}</span></td>
        </tr>

        <tr class="picking-parcels-row" *ngIf="isLoadingListExpanded(warehouseCode, trip, ll)">
          <td colspan="11">
            <ng-container *ngTemplateOutlet="parcelsTable; context: { parcels: ll.parcels, loadingListCode: ll.loadingListCode, tripCode: trip.tripCode }"></ng-container>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="!loadingLists || loadingLists.length === 0">
        <td colspan="11" class="text-center text-muted py-3">Nessun borderò collegato a questo viaggio</td>
      </tr>
    </tbody>
  </table>
  </div>
</ng-template>

<!-- Template riutilizzabile: sotto-tabella dei colli di un viaggio -->
<ng-template #parcelsTable let-parcels="parcels" let-loadingListCode="loadingListCode" let-tripCode="tripCode">
  <div class="picking-breadcrumb" *ngIf="tripCode || loadingListCode">
    <i class="fas fa-box-open"></i>
    <span>Colli</span>
    <ng-container *ngIf="tripCode">
      <i class="fas fa-chevron-right"></i>
      <span class="picking-breadcrumb-chip picking-breadcrumb-chip--trip"><i class="fas fa-route"></i>Viaggio {{ tripCode }}</span>
    </ng-container>
    <ng-container *ngIf="loadingListCode">
      <i class="fas fa-chevron-right"></i>
      <span class="picking-breadcrumb-chip picking-breadcrumb-chip--loading-list"><i class="fas fa-clipboard-list"></i>Borderò {{ loadingListCode }}</span>
    </ng-container>
  </div>
  <div class="picking-nested-scroll">
  <table class="table table-sm wm-subtable mb-0">
    <thead>
    <tr>
      <th class="sortable-th" (click)="setParcelSort('parcelCode')">
        <div class="wm-th-content">
          Codice Collo
          <i class="fas" [ngClass]="getParcelSortIcon('parcelCode')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('parcelCode')"
             (click)="toggleParcelFilterPopover('parcelCode', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'parcelCode'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['parcelCode']" placeholder="Filtra per codice..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['parcelCode']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('parcelCode')" (change)="toggleAllParcelValues('parcelCode')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('parcelCode')">
                <input type="checkbox" [checked]="isParcelValueChecked('parcelCode', v)" (change)="toggleParcelValue('parcelCode', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('parcelCode').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('parcelCode')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setParcelSort('eventDate')">
        <div class="wm-th-content">
          Data Picking
          <i class="fas" [ngClass]="getParcelSortIcon('eventDate')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('eventDate')"
             (click)="toggleParcelFilterPopover('eventDate', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'eventDate'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['eventDate']" placeholder="Filtra per data..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['eventDate']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('eventDate')" (change)="toggleAllParcelValues('eventDate')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('eventDate')">
                <input type="checkbox" [checked]="isParcelValueChecked('eventDate', v)" (change)="toggleParcelValue('eventDate', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('eventDate').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('eventDate')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="text-center sortable-th" (click)="setParcelSort('pickingStatus')">
        <div class="wm-th-content wm-th-content--center">
          Stato
          <i class="fas" [ngClass]="getParcelSortIcon('pickingStatus')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('pickingStatus')"
             (click)="toggleParcelFilterPopover('pickingStatus', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'pickingStatus'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['pickingStatus']" placeholder="Filtra per stato..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['pickingStatus']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('pickingStatus')" (change)="toggleAllParcelValues('pickingStatus')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('pickingStatus')">
                <input type="checkbox" [checked]="isParcelValueChecked('pickingStatus', v)" (change)="toggleParcelValue('pickingStatus', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('pickingStatus').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('pickingStatus')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setParcelSort('clientName')">
        <div class="wm-th-content">
          Cliente
          <i class="fas" [ngClass]="getParcelSortIcon('clientName')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('clientName')"
             (click)="toggleParcelFilterPopover('clientName', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'clientName'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['clientName']" placeholder="Filtra per cliente..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['clientName']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('clientName')" (change)="toggleAllParcelValues('clientName')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('clientName')">
                <input type="checkbox" [checked]="isParcelValueChecked('clientName', v)" (change)="toggleParcelValue('clientName', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('clientName').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('clientName')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setParcelSort('waybillCode')">
        <div class="wm-th-content">
          Bolla
          <i class="fas" [ngClass]="getParcelSortIcon('waybillCode')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('waybillCode')"
             (click)="toggleParcelFilterPopover('waybillCode', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'waybillCode'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['waybillCode']" placeholder="Filtra per bolla..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['waybillCode']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('waybillCode')" (change)="toggleAllParcelValues('waybillCode')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('waybillCode')">
                <input type="checkbox" [checked]="isParcelValueChecked('waybillCode', v)" (change)="toggleParcelValue('waybillCode', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('waybillCode').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('waybillCode')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="text-end sortable-th" (click)="setParcelSort('parcelWeight')">
        <div class="wm-th-content wm-th-content--end">
          Peso (kg)
          <i class="fas" [ngClass]="getParcelSortIcon('parcelWeight')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('parcelWeight')"
             (click)="toggleParcelFilterPopover('parcelWeight', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'parcelWeight'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['parcelWeight']" placeholder="Filtra per peso..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['parcelWeight']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('parcelWeight')" (change)="toggleAllParcelValues('parcelWeight')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('parcelWeight')">
                <input type="checkbox" [checked]="isParcelValueChecked('parcelWeight', v)" (change)="toggleParcelValue('parcelWeight', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('parcelWeight').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('parcelWeight')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="text-end sortable-th" (click)="setParcelSort('parcelVolume')">
        <div class="wm-th-content wm-th-content--end">
          Volume (m3)
          <i class="fas" [ngClass]="getParcelSortIcon('parcelVolume')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('parcelVolume')"
             (click)="toggleParcelFilterPopover('parcelVolume', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'parcelVolume'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['parcelVolume']" placeholder="Filtra per volume..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['parcelVolume']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('parcelVolume')" (change)="toggleAllParcelValues('parcelVolume')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('parcelVolume')">
                <input type="checkbox" [checked]="isParcelValueChecked('parcelVolume', v)" (change)="toggleParcelValue('parcelVolume', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('parcelVolume').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('parcelVolume')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setParcelSort('parcelDescription')">
        <div class="wm-th-content">
          Descrizione
          <i class="fas" [ngClass]="getParcelSortIcon('parcelDescription')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('parcelDescription')"
             (click)="toggleParcelFilterPopover('parcelDescription', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'parcelDescription'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['parcelDescription']" placeholder="Filtra per descrizione..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['parcelDescription']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('parcelDescription')" (change)="toggleAllParcelValues('parcelDescription')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('parcelDescription')">
                <input type="checkbox" [checked]="isParcelValueChecked('parcelDescription', v)" (change)="toggleParcelValue('parcelDescription', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('parcelDescription').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('parcelDescription')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
      <th class="sortable-th" (click)="setParcelSort('parcelOriginWarehouseShortName')">
        <div class="wm-th-content">
          Magazzino Partenza
          <i class="fas" [ngClass]="getParcelSortIcon('parcelOriginWarehouseShortName')"></i>
          <i class="fas fa-filter wm-col-filter-icon" [class.active]="isParcelFilterActive('parcelOriginWarehouseShortName')"
             (click)="toggleParcelFilterPopover('parcelOriginWarehouseShortName', $event)"></i>
          <div class="wm-col-filter-popover" *ngIf="openParcelFilterKey === 'parcelOriginWarehouseShortName'" [style.top]="parcelFilterPopoverStyle.top" [style.left]="parcelFilterPopoverStyle.left" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="parcelColumnFilters['parcelOriginWarehouseShortName']" placeholder="Filtra per magazzino..."
                   (click)="$event.stopPropagation()">
            <div class="wm-col-filter-divider"></div>
            <div class="wm-col-filter-section-label">Valori</div>
            <div class="wm-col-filter-value-search">
              <input type="text" [(ngModel)]="parcelValueSearch['parcelOriginWarehouseShortName']" placeholder="Cerca valore...">
            </div>
            <div class="wm-col-filter-value-list">
              <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                <input type="checkbox" [checked]="areAllParcelValuesChecked('parcelOriginWarehouseShortName')" (change)="toggleAllParcelValues('parcelOriginWarehouseShortName')">
                Seleziona tutto
              </label>
              <label class="wm-col-filter-value-item" *ngFor="let v of getParcelValueOptions('parcelOriginWarehouseShortName')">
                <input type="checkbox" [checked]="isParcelValueChecked('parcelOriginWarehouseShortName', v)" (change)="toggleParcelValue('parcelOriginWarehouseShortName', v)">
                {{ v }}
              </label>
              <div class="wm-col-filter-value-empty" *ngIf="getParcelValueOptions('parcelOriginWarehouseShortName').length === 0">Nessun valore</div>
            </div>
            <div class="wm-col-filter-popover-actions">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearParcelFilter('parcelOriginWarehouseShortName')">Pulisci</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeParcelFilterPopover()">Applica</button>
            </div>
          </div>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
      <tr class="wm-parcel-subrow" *ngFor="let p of getPaginatedParcels(parcels, loadingListCode, tripCode); trackBy: trackByParcelCode">
        <td class="rt-strong">
          <div class="d-flex align-items-center gap-1">
            <span class="rt-code clickable-code" (click)="openParcelDetail(p, $event)"
                  matTooltip="Vedi dettagli collo">{{ p.parcelCode || p.parcelBarcode || '-' }}</span>
            <i class="fas fa-copy copy-icon"
               (click)="$event.stopPropagation(); copyToClipboard(p.parcelCode || p.parcelBarcode, 'collo')"
               matTooltip="Copia codice collo"></i>
          </div>
        </td>
        <td class="rt-date">{{ formatDateTime(p.eventDate) }}</td>
        <td class="text-center">
          <span [ngClass]="getPickingStatusBadgeClass(p.pickingStatus)">{{ getPickingStatusLabel(p.pickingStatus) }}</span>
        </td>
        <td>
          <div class="d-flex align-items-center gap-1">
            <span class="picking-cell-truncate" [matTooltip]="p.clientName || ''">{{ p.clientName || '-' }}</span>
            <i class="fas fa-copy copy-icon" *ngIf="p.clientName" (click)="$event.stopPropagation(); copyToClipboard(p.clientName, 'cliente')"
               matTooltip="Copia cliente"></i>
          </div>
        </td>
        <td>
          <div class="d-flex align-items-center gap-1">
            <span class="picking-cell-truncate" [matTooltip]="p.waybillCode || ''">{{ p.waybillCode || '-' }}</span>
            <i class="fas fa-copy copy-icon" *ngIf="p.waybillCode" (click)="$event.stopPropagation(); copyToClipboard(p.waybillCode, 'bolla')"
               matTooltip="Copia bolla"></i>
          </div>
        </td>
        <td class="text-end rt-date">{{ p.parcelWeight != null ? (p.parcelWeight | number:'1.0-2') : '-' }}</td>
        <td class="text-end rt-date">{{ p.parcelVolume != null ? (p.parcelVolume | number:'1.0-4') : '-' }}</td>
        <td>
          <div class="d-flex align-items-center gap-1">
            <span class="picking-cell-truncate picking-cell-truncate--wide"
                  *ngIf="p.parcelDescription || p.parcelPalletType; else noDesc"
                  [matTooltip]="(p.parcelDescription || '') + ((p.parcelDescription && p.parcelPalletType) ? ' - ' : '') + (p.parcelPalletType || '')">
              {{ p.parcelDescription }}<span *ngIf="p.parcelDescription && p.parcelPalletType"> - </span>{{ p.parcelPalletType }}
            </span>
            <ng-template #noDesc><span class="text-muted">-</span></ng-template>
            <i class="fas fa-copy copy-icon" *ngIf="p.parcelDescription || p.parcelPalletType"
               (click)="$event.stopPropagation(); copyToClipboard((p.parcelDescription || '') + ((p.parcelDescription && p.parcelPalletType) ? ' - ' : '') + (p.parcelPalletType || ''), 'descrizione')"
               matTooltip="Copia descrizione"></i>
          </div>
        </td>
        <td>
          <div class="d-flex align-items-center gap-1">
            <span class="picking-cell-truncate" [matTooltip]="p.parcelOriginWarehouseShortName || ''">{{ p.parcelOriginWarehouseShortName || '-' }}</span>
            <i class="fas fa-copy copy-icon" *ngIf="p.parcelOriginWarehouseShortName" (click)="$event.stopPropagation(); copyToClipboard(p.parcelOriginWarehouseShortName, 'magazzino')"
               matTooltip="Copia magazzino"></i>
          </div>
        </td>
      </tr>
      <tr *ngIf="!parcels || parcels.length === 0">
        <td colspan="9" class="text-center text-muted py-3">Nessun collo</td>
      </tr>
    </tbody>
  </table>
  </div>

  <div class="picking-parcels-pagination" *ngIf="parcels && parcels.length > parcelsPageSize">
    <button type="button" class="pagination-btn" (click)="goToParcelsPage(getParcelsPage(loadingListCode, tripCode) - 1, parcels, loadingListCode, tripCode)"
            [disabled]="getParcelsPage(loadingListCode, tripCode) === 1" title="Precedente">
      <i class="fas fa-chevron-left"></i>
    </button>
    <div class="picking-parcels-page-numbers">
      <button *ngFor="let page of getParcelsPageNumbers(parcels, loadingListCode, tripCode)"
              class="pagination-number"
              [class.active]="page === getParcelsPage(loadingListCode, tripCode)"
              (click)="goToParcelsPage(page, parcels, loadingListCode, tripCode)">
        {{ page }}
      </button>
    </div>
    <span class="picking-parcels-pagination-info">
      {{ getParcelsRangeStart(parcels, loadingListCode, tripCode) }} - {{ getParcelsRangeEnd(parcels, loadingListCode, tripCode) }} di {{ getFilteredSortedParcels(parcels).length }}
    </span>
    <button type="button" class="pagination-btn" (click)="goToParcelsPage(getParcelsPage(loadingListCode, tripCode) + 1, parcels, loadingListCode, tripCode)"
            [disabled]="getParcelsPage(loadingListCode, tripCode) === getParcelsTotalPages(parcels, loadingListCode, tripCode)" title="Successivo">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</ng-template>

<!-- Popup dettaglio collo -->
<div class="popup-overlay" *ngIf="selectedParcelForModal" (click)="closeParcelDetail()">
  <div class="popup-content picking-detail-popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title">
        <button type="button" class="btn-back-arrow" *ngIf="parcelDetailReturnsToStatusList"
                (click)="backFromParcelDetailToStatusList()" title="Torna all'elenco" aria-label="Torna all'elenco">
          <i class="fas fa-arrow-left"></i>
        </button>
        <i class="fas fa-box me-2"></i>
        Collo {{ selectedParcelForModal?.parcelCode || selectedParcelForModal?.parcelBarcode }}
      </h2>
      <button type="button" class="btn-close" (click)="closeParcelDetail()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body picking-detail-popup-body" *ngIf="selectedParcelForModal as p">
      <div class="picking-detail-grid">

        <div class="picking-detail-item" *ngIf="p.parcelBarcode">
          <div class="picking-detail-label"><i class="fas fa-barcode me-1"></i>Barcode</div>
          <div class="picking-detail-value d-flex align-items-center gap-1">
            <span>{{ p.parcelBarcode }}</span>
            <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.parcelBarcode, 'barcode')" matTooltip="Copia barcode"></i>
          </div>
        </div>

        <div class="picking-detail-item">
          <div class="picking-detail-label"><i class="fas fa-clock me-1"></i>Data / ora picking</div>
          <div class="picking-detail-value d-flex align-items-center gap-1">
            <span>{{ formatDateTime(p.eventDate) }}</span>
            <i class="fas fa-copy copy-icon" *ngIf="p.eventDate" (click)="copyToClipboard(formatDateTime(p.eventDate), 'data picking')" matTooltip="Copia data picking"></i>
          </div>
        </div>

        <div class="picking-detail-item">
          <div class="picking-detail-label"><i class="fas fa-warehouse me-1"></i>Piattaforma picking</div>
          <div class="picking-detail-value d-flex align-items-center gap-1">
            <span>{{ p.warehouseName || '-' }}</span>
            <i class="fas fa-copy copy-icon" *ngIf="p.warehouseName" (click)="copyToClipboard(p.warehouseName, 'piattaforma')" matTooltip="Copia piattaforma"></i>
          </div>
        </div>

        <div class="picking-detail-item">
          <div class="picking-detail-label"><i class="fas fa-flag me-1"></i>Stato</div>
          <div class="picking-detail-value">
            <span [ngClass]="getPickingStatusBadgeClass(p.pickingStatus)">{{ getPickingStatusLabel(p.pickingStatus) }}</span>
          </div>
        </div>

        <ng-container *ngIf="!p.isOrphan">
          <div class="picking-detail-item" *ngIf="p.clientName">
            <div class="picking-detail-label"><i class="fas fa-building me-1"></i>Cliente</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.clientName }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.clientName, 'cliente')" matTooltip="Copia cliente"></i>
            </div>
          </div>

          <div class="picking-detail-item" *ngIf="p.waybillCode">
            <div class="picking-detail-label"><i class="fas fa-file-lines me-1"></i>Bolla</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.waybillCode }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.waybillCode, 'bolla')" matTooltip="Copia bolla"></i>
            </div>
          </div>

          <div class="picking-detail-item" *ngIf="p.parcelWeight != null">
            <div class="picking-detail-label"><i class="fas fa-weight-hanging me-1"></i>Peso</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ formatKg(p.parcelWeight) }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(formatKg(p.parcelWeight), 'peso')" matTooltip="Copia peso"></i>
            </div>
          </div>

          <div class="picking-detail-item" *ngIf="p.parcelVolume != null">
            <div class="picking-detail-label"><i class="fas fa-cube me-1"></i>Volume</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ formatM3(p.parcelVolume) }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(formatM3(p.parcelVolume), 'volume')" matTooltip="Copia volume"></i>
            </div>
          </div>

          <div class="picking-detail-item" *ngIf="p.parcelDescription || p.parcelPalletType">
            <div class="picking-detail-label"><i class="fas fa-tag me-1"></i>Descrizione</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.parcelDescription }}<span *ngIf="p.parcelDescription && p.parcelPalletType"> - </span>{{ p.parcelPalletType }}</span>
              <i class="fas fa-copy copy-icon"
                 (click)="copyToClipboard((p.parcelDescription || '') + ((p.parcelDescription && p.parcelPalletType) ? ' - ' : '') + (p.parcelPalletType || ''), 'descrizione')"
                 matTooltip="Copia descrizione"></i>
            </div>
          </div>
        </ng-container>

      </div>

      <div class="picking-detail-section" *ngIf="!p.isOrphan && p.tripCode">
        <div class="picking-detail-section-title">
          <i class="fas fa-route me-2"></i>Viaggio
        </div>
        <div class="picking-detail-grid">
          <div class="picking-detail-item">
            <div class="picking-detail-label"><i class="fas fa-hashtag me-1"></i>Viaggio</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.tripCode }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.tripCode, 'viaggio')" matTooltip="Copia codice viaggio"></i>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.tripCarrierName">
            <div class="picking-detail-label"><i class="fas fa-truck me-1"></i>Vettore</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.tripCarrierName }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.tripCarrierName, 'vettore')" matTooltip="Copia vettore"></i>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.tripPlateNo">
            <div class="picking-detail-label"><i class="fas fa-id-card me-1"></i>Targa</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.tripPlateNo }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.tripPlateNo, 'targa')" matTooltip="Copia targa"></i>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.shuttleArrivalDate">
            <div class="picking-detail-label"><i class="fas fa-clock-rotate-left me-1"></i>Data Arrivo</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ formatDateTime(p.shuttleArrivalDate) }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(formatDateTime(p.shuttleArrivalDate), 'data arrivo')" matTooltip="Copia data arrivo"></i>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.tripOriginWarehouses">
            <div class="picking-detail-label"><i class="fas fa-warehouse me-1"></i>Magazzini Partenza</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.tripOriginWarehouses.split(';').join(', ') }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.tripOriginWarehouses.split(';').join(', '), 'magazzini partenza')" matTooltip="Copia magazzini partenza"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="picking-detail-section" *ngIf="!p.isOrphan && p.loadingListCode">
        <div class="picking-detail-section-title">
          <i class="fas fa-clipboard-list me-2"></i>Borderò
        </div>
        <div class="picking-detail-grid">
          <div class="picking-detail-item">
            <div class="picking-detail-label"><i class="fas fa-hashtag me-1"></i>Borderò</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.loadingListCode }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.loadingListCode, 'borderò')" matTooltip="Copia codice borderò"></i>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.warehouseDirection">
            <div class="picking-detail-label"><i class="fas fa-arrows-left-right me-1"></i>Direzione</div>
            <div class="picking-detail-value">
              <span class="picking-direction-badge"
                    [class.picking-direction-badge--departure]="p.warehouseDirection === 'DEPARTURE'"
                    [class.picking-direction-badge--arrival]="p.warehouseDirection === 'ARRIVAL'">
                {{ p.warehouseDirection === 'DEPARTURE' ? 'Carico' : 'Scarico' }}
              </span>
            </div>
          </div>
          <div class="picking-detail-item" *ngIf="p.loadingListTourGroups">
            <div class="picking-detail-label"><i class="fas fa-flag me-1"></i>Tour</div>
            <div class="picking-detail-value d-flex align-items-center gap-1">
              <span>{{ p.loadingListTourGroups }}</span>
              <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.loadingListTourGroups, 'tour')" matTooltip="Copia tour"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="picking-detail-dealer" *ngIf="p.dealerName">
        <div class="picking-detail-dealer-title">
          <i class="fas fa-location-dot me-2"></i>Destinatario
          <i class="fas fa-copy copy-icon" (click)="copyToClipboard(p.dealerName + ((p.dealerAddressStreet || p.dealerAddressCity) ? ' - ' + (p.dealerAddressStreet || '') + (p.dealerAddressCity ? ', ' + p.dealerAddressCity : '') : ''), 'destinatario')"
             matTooltip="Copia destinatario"></i>
        </div>
        <div class="picking-detail-dealer-name">{{ p.dealerName }}</div>
        <div class="picking-detail-dealer-address">
          <span *ngIf="p.dealerAddressStreet">{{ p.dealerAddressStreet }}</span>
          <span *ngIf="p.dealerAddressCity">, {{ p.dealerAddressCity }}</span>
          <span *ngIf="p.dealerAddressProvince"> ({{ p.dealerAddressProvince }})</span>
          <span *ngIf="p.dealerAddressZip"> - {{ p.dealerAddressZip }}</span>
        </div>
      </div>

      <div class="alert alert-light border mt-3 mb-0" *ngIf="p.isOrphan">
        <i class="fas fa-triangle-exclamation me-2 text-warning"></i>
        Scansione di picking senza un collo o un affido collegato: non sono disponibili ulteriori informazioni.
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-outline-secondary" *ngIf="parcelDetailReturnsToStatusList"
                (click)="backFromParcelDetailToStatusList()">
          <i class="fas fa-arrow-left me-1"></i>Torna all'elenco
        </button>
        <div class="ms-auto">
          <button type="button" class="btn btn-secondary" (click)="closeParcelDetail()">Chiudi</button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Popup elenco colli per stato (pickerati / pickerabili / non pickerati) -->
<div class="popup-overlay" *ngIf="statusListPopup && !selectedParcelForModal" (click)="closeStatusListPopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title">
        <i class="me-2" [ngClass]="[getStatusListIcon(), getStatusListColorClass()]"></i>
        {{ getStatusListTitle() }} (<span [ngClass]="getStatusListColorClass()">{{ getStatusListParcels().length }}</span>)
      </h2>
      <button type="button" class="btn-close" (click)="closeStatusListPopup()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="picking-orphans-scroll">
        <table class="table table-sm wm-subtable mb-0 picking-status-list-table">
          <thead>
          <tr [ngClass]="getStatusListColorClass()">
            <th class="sortable-th" (click)="setStatusListSort('parcelCode')">
              <div class="wm-th-content">
                Collo
                <i class="fas" [ngClass]="getStatusListSortIcon('parcelCode')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('parcelCode')"
                   (click)="toggleStatusListFilterPopover('parcelCode', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'parcelCode'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['parcelCode']" placeholder="Filtra per codice..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['parcelCode']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('parcelCode')" (change)="toggleAllStatusListValues('parcelCode')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('parcelCode')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('parcelCode', v)" (change)="toggleStatusListValue('parcelCode', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('parcelCode').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('parcelCode')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" *ngIf="statusListPopup === 'EXECUTED' || statusListPopup === 'ALL'" (click)="setStatusListSort('eventDate')">
              <div class="wm-th-content">
                Data Picking
                <i class="fas" [ngClass]="getStatusListSortIcon('eventDate')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('eventDate')"
                   (click)="toggleStatusListFilterPopover('eventDate', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'eventDate'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['eventDate']" placeholder="Filtra per data..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['eventDate']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('eventDate')" (change)="toggleAllStatusListValues('eventDate')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('eventDate')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('eventDate', v)" (change)="toggleStatusListValue('eventDate', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('eventDate').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('eventDate')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setStatusListSort('warehouseName')">
              <div class="wm-th-content">
                Magazzino
                <i class="fas" [ngClass]="getStatusListSortIcon('warehouseName')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('warehouseName')"
                   (click)="toggleStatusListFilterPopover('warehouseName', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'warehouseName'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['warehouseName']" placeholder="Filtra per magazzino..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['warehouseName']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('warehouseName')" (change)="toggleAllStatusListValues('warehouseName')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('warehouseName')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('warehouseName', v)" (change)="toggleStatusListValue('warehouseName', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('warehouseName').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('warehouseName')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setStatusListSort('tripCode')">
              <div class="wm-th-content">
                Viaggio
                <i class="fas" [ngClass]="getStatusListSortIcon('tripCode')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('tripCode')"
                   (click)="toggleStatusListFilterPopover('tripCode', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'tripCode'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['tripCode']" placeholder="Filtra per viaggio..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['tripCode']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('tripCode')" (change)="toggleAllStatusListValues('tripCode')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('tripCode')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('tripCode', v)" (change)="toggleStatusListValue('tripCode', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('tripCode').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('tripCode')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" (click)="setStatusListSort('loadingListCode')">
              <div class="wm-th-content">
                Borderò
                <i class="fas" [ngClass]="getStatusListSortIcon('loadingListCode')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('loadingListCode')"
                   (click)="toggleStatusListFilterPopover('loadingListCode', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'loadingListCode'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['loadingListCode']" placeholder="Filtra per borderò..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['loadingListCode']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('loadingListCode')" (change)="toggleAllStatusListValues('loadingListCode')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('loadingListCode')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('loadingListCode', v)" (change)="toggleStatusListValue('loadingListCode', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('loadingListCode').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('loadingListCode')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="text-end sortable-th" *ngIf="statusListPopup === 'ALL'" (click)="setStatusListSort('pickingStatus')">
              <div class="wm-th-content wm-th-content--end">
                Stato
                <i class="fas" [ngClass]="getStatusListSortIcon('pickingStatus')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isStatusListFilterActive('pickingStatus')"
                   (click)="toggleStatusListFilterPopover('pickingStatus', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openStatusListFilterKey === 'pickingStatus'" [style.top]="statusListFilterPopoverStyle.top" [style.left]="statusListFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="statusListColumnFilters['pickingStatus']" placeholder="Filtra per stato..." (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="statusListValueSearch['pickingStatus']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllStatusListValuesChecked('pickingStatus')" (change)="toggleAllStatusListValues('pickingStatus')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getStatusListValueOptions('pickingStatus')">
                      <input type="checkbox" [checked]="isStatusListValueChecked('pickingStatus', v)" (change)="toggleStatusListValue('pickingStatus', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getStatusListValueOptions('pickingStatus').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusListFilter('pickingStatus')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="closeStatusListFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
            <tr class="wm-parcel-subrow" *ngFor="let p of getFilteredSortedStatusListParcels()">
              <td class="rt-strong">
                <div class="d-flex align-items-center gap-1">
                  <span class="rt-code clickable-code" (click)="openParcelDetailFromStatusList(p)">{{ p.parcelCode || p.parcelBarcode || '-' }}</span>
                  <i class="fas fa-copy copy-icon" (click)="$event.stopPropagation(); copyToClipboard(p.parcelCode || p.parcelBarcode, 'collo')"
                     matTooltip="Copia codice collo"></i>
                </div>
              </td>
              <td class="rt-date" *ngIf="statusListPopup === 'EXECUTED' || statusListPopup === 'ALL'">{{ p.eventDate ? formatDateTime(p.eventDate) : '-' }}</td>
              <td>
                <div class="d-flex align-items-center gap-1">
                  <span class="picking-cell-truncate" [matTooltip]="p.warehouseName || ''">{{ p.warehouseName || '-' }}</span>
                  <i class="fas fa-copy copy-icon" *ngIf="p.warehouseName" (click)="$event.stopPropagation(); copyToClipboard(p.warehouseName, 'magazzino')"
                     matTooltip="Copia magazzino"></i>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center gap-1">
                  <span>{{ p.tripCode || '-' }}</span>
                  <i class="fas fa-copy copy-icon" *ngIf="p.tripCode" (click)="$event.stopPropagation(); copyToClipboard(p.tripCode, 'viaggio')"
                     matTooltip="Copia codice viaggio"></i>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center gap-1">
                  <span>{{ p.loadingListCode || '-' }}</span>
                  <i class="fas fa-copy copy-icon" *ngIf="p.loadingListCode" (click)="$event.stopPropagation(); copyToClipboard(p.loadingListCode, 'borderò')"
                     matTooltip="Copia codice borderò"></i>
                </div>
              </td>
              <td class="text-end" *ngIf="statusListPopup === 'ALL'">
                <span [ngClass]="getPickingStatusBadgeClass(p.pickingStatus)">{{ getPickingStatusLabel(p.pickingStatus) }}</span>
              </td>
            </tr>
            <tr *ngIf="getFilteredSortedStatusListParcels().length === 0">
              <td [attr.colspan]="(statusListPopup === 'EXECUTED' || statusListPopup === 'ALL') ? 6 : 5" class="text-center text-muted py-3">Nessun collo</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="closeStatusListPopup()">Chiudi</button>
      </div>
    </div>

  </div>
</div>

<!-- Popup elenco pickerati senza affido -->
<div class="popup-overlay" *ngIf="showOrphansListPopup" (click)="closeOrphansListPopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-question me-2 picking-orphan-title-icon"></i>
        Pickerati senza affido (<span class="picking-orphan-title-icon">{{ allOrphanParcels.length }}</span>)
      </h2>
      <button type="button" class="btn-close" (click)="closeOrphansListPopup()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="picking-orphans-scroll">
        <table class="table table-sm wm-subtable mb-0 picking-orphans-table">
          <thead>
          <tr>
            <th class="sortable-th" (click)="setOrphanSort('parcelBarcode')">
              <div class="wm-th-content">
                Barcode
                <i class="fas" [ngClass]="getOrphanSortIcon('parcelBarcode')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isOrphanFilterActive('parcelBarcode')"
                   (click)="toggleOrphanFilterPopover('parcelBarcode', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openOrphanFilterKey === 'parcelBarcode'"
                     [style.top]="orphanFilterPopoverStyle.top" [style.left]="orphanFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="orphanColumnFilters['parcelBarcode']" placeholder="Filtra per barcode..."
                         (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="orphanValueSearch['parcelBarcode']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllOrphanValuesChecked('parcelBarcode')" (change)="toggleAllOrphanValues('parcelBarcode')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getOrphanValueOptions('parcelBarcode')">
                      <input type="checkbox" [checked]="isOrphanValueChecked('parcelBarcode', v)" (change)="toggleOrphanValue('parcelBarcode', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getOrphanValueOptions('parcelBarcode').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearOrphanFilter('parcelBarcode')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyOrphanFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" style="padding-left: 8px;" (click)="setOrphanSort('warehouseName')">
              <div class="wm-th-content">
                Piattaforma
                <i class="fas" [ngClass]="getOrphanSortIcon('warehouseName')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isOrphanFilterActive('warehouseName')"
                   (click)="toggleOrphanFilterPopover('warehouseName', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openOrphanFilterKey === 'warehouseName'"
                     [style.top]="orphanFilterPopoverStyle.top" [style.left]="orphanFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="orphanColumnFilters['warehouseName']" placeholder="Filtra per piattaforma..."
                         (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="orphanValueSearch['warehouseName']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllOrphanValuesChecked('warehouseName')" (change)="toggleAllOrphanValues('warehouseName')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getOrphanValueOptions('warehouseName')">
                      <input type="checkbox" [checked]="isOrphanValueChecked('warehouseName', v)" (change)="toggleOrphanValue('warehouseName', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getOrphanValueOptions('warehouseName').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearOrphanFilter('warehouseName')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyOrphanFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
            <th class="sortable-th" style="padding-left: 3px;" (click)="setOrphanSort('eventDate')">
              <div class="wm-th-content">
                Data / ora picking
                <i class="fas" [ngClass]="getOrphanSortIcon('eventDate')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isOrphanFilterActive('eventDate')"
                   (click)="toggleOrphanFilterPopover('eventDate', $event)"></i>
                <div class="wm-col-filter-popover" *ngIf="openOrphanFilterKey === 'eventDate'"
                     [style.top]="orphanFilterPopoverStyle.top" [style.left]="orphanFilterPopoverStyle.left" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="orphanColumnFilters['eventDate']" placeholder="Filtra per data..."
                         (click)="$event.stopPropagation()">
                  <div class="wm-col-filter-divider"></div>
                  <div class="wm-col-filter-section-label">Valori</div>
                  <div class="wm-col-filter-value-search">
                    <input type="text" [(ngModel)]="orphanValueSearch['eventDate']" placeholder="Cerca valore...">
                  </div>
                  <div class="wm-col-filter-value-list">
                    <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
                      <input type="checkbox" [checked]="areAllOrphanValuesChecked('eventDate')" (change)="toggleAllOrphanValues('eventDate')">
                      Seleziona tutto
                    </label>
                    <label class="wm-col-filter-value-item" *ngFor="let v of getOrphanValueOptions('eventDate')">
                      <input type="checkbox" [checked]="isOrphanValueChecked('eventDate', v)" (change)="toggleOrphanValue('eventDate', v)">
                      {{ v }}
                    </label>
                    <div class="wm-col-filter-value-empty" *ngIf="getOrphanValueOptions('eventDate').length === 0">Nessun valore</div>
                  </div>
                  <div class="wm-col-filter-popover-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearOrphanFilter('eventDate')">Pulisci</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyOrphanFilterPopover()">Applica</button>
                  </div>
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
            <tr class="wm-parcel-subrow" *ngFor="let p of getFilteredSortedOrphans(); trackBy: trackByParcelCode">
              <td class="rt-strong"><span class="picking-cell-truncate" [matTooltip]="p.parcelBarcode || p.parcelCode || ''">{{ p.parcelBarcode || p.parcelCode || '-' }}</span></td>
              <td><span class="picking-cell-truncate" [matTooltip]="p.warehouseName || ''">{{ p.warehouseName || '-' }}</span></td>
              <td class="rt-date">{{ formatDateTime(p.eventDate) }}</td>
            </tr>
            <tr *ngIf="getFilteredSortedOrphans().length === 0">
              <td colspan="3" class="text-center text-muted py-3">Nessun collo pickerato senza affido</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="closeOrphansListPopup()">Chiudi</button>
      </div>
    </div>

  </div>
</div>